import {Component, OnInit} from '@angular/core';
import {BlockStatementAbstractComponent} from '../block-statement-abstract.component';

@Component({
    selector: 'core-value-statement',
    templateUrl: './block-value-statement.component.html',
    standalone: false
})
export class BlockValueStatementComponent extends BlockStatementAbstractComponent implements OnInit {
    videoId!: string;
    isVideoRequired!: boolean;
    videoUrl: any;
    videoUrlForPrint!: string;

    image!: string;
    speaker!: string;
    speakerRole!: string;
    text!: string;

    override ngOnInit(): void {
        super.ngOnInit();
        this.videoId = this.trsService.getValueStatementVideoId();
        this.isVideoRequired = this.trsService.isVideoShown();
        this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('//fast.wistia.net/embed/iframe/' + this.videoId + '?autoPlay=false');
        this.videoUrlForPrint = 'https://fast.wistia.net/embed/iframe/' + this.videoId + '?autoPlay=false';

        this.image = this.trsService.getValueStatementImage();
        this.speaker = this.trsService.getValueStatementSpeakerName();
        this.speakerRole = this.trsService.getValueStatementSpeakerRole();
        this.text = this.trsService.getValueStatementText();
    }

}
